import { render } from "./AdminPortfolioModal.vue?vue&type=template&id=0ae3dafa&scoped=true"
import script from "./AdminPortfolioModal.vue?vue&type=script&lang=js"
export * from "./AdminPortfolioModal.vue?vue&type=script&lang=js"

import "./AdminPortfolioModal.vue?vue&type=style&index=0&id=0ae3dafa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae3dafa"]])

export default __exports__